import { LitElement, html, svg } from 'lit';

export class IconPlus16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Pluss</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 8h11M8 2.5v11"></path></svg>`; }
}
if (!customElements.get('f-icon-plus16', IconPlus16)) {
  customElements.define('f-icon-plus16', IconPlus16);
}